export default __webpack_public_path__ + "static/media/time-frog.139ac8b5.jpeg";